<template>
  <app-layout>
    <div class="py-12 max-w-6xl mx-auto">
      <div
        class="
          bg-gray-50
          max-w-screen-sm
          mx-auto
          shadow
          border-vice-dark-grey
          overflow-hidden
          sm:rounded-lg
          mt-10
        "
      >
        <div class="px-4 py-5 sm:px-6 border">
          <h3 class="text-lg leading-6 font-medium text-vice-teal-700">Application Accept</h3>
        </div>
        <!-- Main 3 column grid -->
        <div class="bg-white border border-t-0 text-center">
          <div class="px-4 py-5 sm:p-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Do you want to accept application?
            </h3>

            <div class="mt-2 max-w-xl m-auto text-sm text-gray-500">
              <p>
                You have request to accept {{ $page.props.session.details.clinician?.name }} as
                {{ $page.props.sessionApply.user_type }} in "{{ $page.props.session.title }}" which
                will start at {{ $page.props.session.details.session_start_by_timezone }}.
              </p>
              <p>Please click accept button to confirm application!</p>
            </div>
            <div class="mt-5">
              <inertia-link
                :href="route('clinician.confirm.user', [$page.props.sessionApply.id])"
                method="post"
                as="button"
                type="button"
                class="
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  text-xs
                  uppercase
                  font-medium
                  rounded-md
                  text-white
                  bg-vice-teal-700
                  hover:bg-vice-teal-200
                  focus:outline-none
                  focus:ring-2 focus:ring-offset-2 focus:ring-vice-teal-500
                "
              >
                Accept application
              </inertia-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
export default {};
</script>
